import {Constructor} from "../../global/constructor";
import ModelCollection from "../models/modelCollection";
import Share from "../models/share";

export default function Shareable<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    shares: ModelCollection<Share> = new ModelCollection<Share>();
  };
}